import React, { useMemo } from 'react';
import { TimeSeriesLineChart } from '@/components/visuals';
import type { ChartDensity } from '@/components/visuals';

export interface SCurveWBSChartProps {
  xAxisData: string[];
  plannedSeries: number[];
  earnedSeries: number[];
  showBaseline?: boolean;
  height?: number | string;
  showDataLabels: boolean;
  density?: ChartDensity;
}

export function SCurveWBSChart({
  xAxisData,
  plannedSeries,
  earnedSeries,
  showBaseline = false,
  height = 260,
  showDataLabels = false,
  density = 'overview',
}: SCurveWBSChartProps) {
  const series = useMemo(() => {
    const base = [
      { name: 'Planned', data: plannedSeries },
      { name: 'Earned', data: earnedSeries },
    ];
    if (!showBaseline) return base;
    return base;
  }, [plannedSeries, earnedSeries, showBaseline]);
  return (
    <TimeSeriesLineChart
      xAxisData={xAxisData}
      series={series}
      height={height}
      showDataLabels={showDataLabels}
      density={density}
    />
  );
}
